(function(){
    angular.module('tmx-app').factory("dialogVm",dialogVm);

    function dialogVm(){
        var vm=this;
        vm.field=field;
        vm.row=row;
        vm.tab=tab;
        vm.dialog=dialog;

        return vm;
    }


    function field(name,type,label,datasource,value,validations,options){
        var aField=this;
        aField.type=type;
        aField.label=label;
        aField.name=name;
        if(angular.isDefined(options) && options!==null)
            aField.options=options;
        if(angular.isDefined(validations)&&validations!=null)
            aField.validations=validations;
        if(angular.isDefined(datasource)&&datasource!=null)
            aField.datasource=datasource;
        if(angular.isDefined(value)&&value!=null)
            aField.value=value;
        else aField.value="";
    }

    function row(fields,name){
        var aRow=this;
        if(angular.isDefined(name))
            aRow.aTab.name=name;
        aRow.fields=fields;
    }

    function tab(name,rows){
        var aTab=this;
        aTab.name=name;
        if(angular.isDefined(rows))
            aTab.rows=rows;
    }

    function dialog(name,tabs){
        var dialog=this;
        dialog.name=name;
        dialog.fields={};
        if(angular.isDefined(tabs)){
            dialog.tabs=tabs;
            tabs.forEach(function(element){
                addTabToMap(element);
            });
        }
	
  
        // eslint-disable-next-line no-unused-vars
        function addTab(tab){
            if(angular.isDefined(tab)){
                dialog.tabs.push(tab);
                addTabToMap(tab);
            }
        }

        function addFieldToMap(field){
            dialog.fields[field.name]=field;
        }

        function addTabToMap(tab){
            if(!angular.isDefined(tab.rows)) return;
            tab.rows.forEach(function(row){
                if(!angular.isDefined(row.fields)) return;
                row.fields.forEach(function(field){
                    addFieldToMap(field);
                });
            });
        }

    }

})();